module.exports = __webpack_public_path__ + "static/media/connection-id.7dc448c6.png";